import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { companyInfo } from '../mock';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../locales/translations';

const Hero = () => {
  const { language } = useLanguage();
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden bg-navy">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1580106815433-a5b1d1d53d85"
          alt="Modern Data Center"
          loading="eager"
          decoding="async"
          fetchpriority="high"
          className="w-full h-full object-cover opacity-30" />

        <div className="absolute inset-0 bg-navy/80"></div>
      </div>

      {/* Animated Background Elements */}
      <div className="absolute inset-0 z-0">
        <div className="hero-floating-element hero-element-1"></div>
        <div className="hero-floating-element hero-element-2"></div>
        <div className="hero-floating-element hero-element-3"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 z-10 relative pt-20">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 mb-6 animate-fade-in-up">
            <div className="w-2 h-2 rounded-full bg-yellow mr-3 animate-pulse"></div>
            <span className="text-white text-sm font-medium">{t(language, 'hero.badge')} {companyInfo.established}</span>
          </div>

          {/* Main Heading with cut-off effect */}
          <div className="mb-6 animate-fade-in-up animation-delay-200 pr-4 w-full">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-2 relative">
              <span className="block text-white leading-tight mb-2 whitespace-nowrap">
                {language === 'en' ? 'Integrating Systems,' : 'Mengintegrasikan Sistem,'}
              </span>
              <span className="block text-yellow leading-tight relative whitespace-nowrap">
                {language === 'en' ? 'Powering Infrastructure.' : 'Menguatkan Infrastruktur.'}
              </span>
            </h1>
          </div>


          {/* Description */}
          <p className="text-base sm:text-lg text-gray-400 mb-8 max-w-3xl leading-relaxed animate-fade-in-up animation-delay-400">
            {language === 'en'
              ? 'Secure, end-to-end system integration solutions across IT infrastructure, data center, cybersecurity, networking, and cloud-based systems designed for rapidly evolving digital ecosystem.'
              : 'Solusi integrasi sistem yang aman dan menyeluruh pada infrastruktur TI, pusat data, keamanan siber, jaringan, serta sistem berbasis cloud.'}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 animate-fade-in-up animation-delay-800">
            <Button
              size="lg"
              onClick={() => scrollToSection('contact')}
              className="bg-yellow hover:bg-yellow-600 text-navy px-8 py-6 text-lg group font-bold">

              {t(language, 'hero.startConsultation')}
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={() => scrollToSection('services')}
              className="border-2 border-white text-white hover:bg-white hover:text-navy px-8 py-6 text-lg backdrop-blur-sm bg-white/10">

              {t(language, 'hero.viewServices')}
            </Button>
          </div>

          {/* Stats */}
          {/* <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mt-16 animate-fade-in-up animation-delay-1000">
            <div className="text-center lg:text-left">
              <div className="text-3xl sm:text-4xl font-bold text-yellow mb-1">500+</div>
              <div className="text-gray-400 text-sm">Proyek Selesai</div>
            </div>
            <div className="text-center lg:text-left">
              <div className="text-3xl sm:text-4xl font-bold text-yellow mb-1">200+</div>
              <div className="text-gray-400 text-sm">Klien Puas</div>
            </div>
            <div className="text-center lg:text-left">
              <div className="text-3xl sm:text-4xl font-bold text-yellow mb-1">50+</div>
              <div className="text-gray-400 text-sm">Partner Teknologi</div>
            </div>
            <div className="text-center lg:text-left">
              <div className="text-3xl sm:text-4xl font-bold text-yellow mb-1">24/7</div>
              <div className="text-gray-400 text-sm">Support</div>
            </div>
          </div> */}
        </div>
      </div>

    </section>);

};

export default Hero;


